import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=0f475c80&"
import script from "./Nav.vue?vue&type=script&lang=ts&"
export * from "./Nav.vue?vue&type=script&lang=ts&"
import style0 from "@/app/assets/styles/layout/_nav.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1212067952/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f475c80')) {
      api.createRecord('0f475c80', component.options)
    } else {
      api.reload('0f475c80', component.options)
    }
    module.hot.accept("./Nav.vue?vue&type=template&id=0f475c80&", function () {
      api.rerender('0f475c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/layout/Nav.vue"
export default component.exports